import type { PatternObject } from "highcharts";

export const getSecondaryColorPattern = (color: string): PatternObject => {
    return {
        pattern: {
            path: {
                d: "M 0 5 L 5 0 M -0.5 0.5 L 0.5 -0.5 M 4.5 5.5 L 5.5 4.5",
                stroke: "rgba(255, 255, 255, 0.76)",
            },
            backgroundColor: color,
            width: 5,
            height: 5,
        },
    };
};
